import { useTranslation } from 'react-i18next';
import { RadioCardGroup } from '@knack/asterisk-react';

import { type QuestionProps, type RadioSelected } from './types';
import { getOnboardingTranslateKey } from './utils';

export function QuestionRadioCards({
  questionId,
  questionOptions,
  disabled,
  selected,
  onChangeSelection
}: QuestionProps<RadioSelected>) {
  const [t] = useTranslation();

  const onValueChange = (option: string) => {
    onChangeSelection({
      option
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm">{t(getOnboardingTranslateKey(questionId, 'title'))}</p>

      <RadioCardGroup
        disabled={disabled}
        className="flex flex-col gap-4"
        defaultValue={selected?.option}
        onValueChange={onValueChange}
      >
        {questionOptions.map((option) => (
          <RadioCardGroup.Card
            key={option}
            value={option}
            width="100%"
            disabled={disabled}
            className={disabled ? 'opacity-70' : 'opacity-100'}
          >
            <div
              className="flex flex-col gap-2"
              data-testid={`onboarding-question-radio-cards-option-${option}`}
              data-disabled={disabled}
            >
              <p className="text-sm font-medium text-emphasis">
                {t(getOnboardingTranslateKey(questionId, 'options', option, 'title'))}
              </p>
              <p className="text-sm">
                {t(getOnboardingTranslateKey(questionId, 'options', option, 'description'))}
              </p>
            </div>
          </RadioCardGroup.Card>
        ))}
      </RadioCardGroup>
    </div>
  );
}
